import { Component, OnInit, EventEmitter, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import * as Materialize from 'angular2-materialize/dist/index';
import { MaterializeDirective, MaterializeAction } from 'angular2-materialize';
import { resourceAdminService } from './resourceadmin.service';
import { NavbarService } from '../navbar/navbar.service';

declare var $: any;

@Component({
  selector: 'app-resourceadmin',
  templateUrl: './resourceadmin.component.html',
  styleUrls: ['./resourceadmin.component.css'],
  providers: [resourceAdminService]
})
export class ResourceadminComponent implements OnInit {

  planid: string;
  index: number;
  noResource: boolean;
  loadingResources: boolean;

  selectedResources = [];
  resources = [];
  resourcesEdit: any = {};
  editcategoryIndex: number;
  categories = [];
  categoriesDict: any = {};
  locations = [];
  locationDict: any = {};
  selectedResourceCostingArray: any = [];
  selectedCategoryValue: any = {};
  selectedResourceValue: any = {};
  Categoryselect: any;
  Locationselect: any;
  CosttypeUnitselect: number;
  selectedCategoryValueName: string;
  costtypes = [];
  costtypeunits = [];
  costings = [];
  costingtypeDict: any = {};
  costtypeunitsDict: any = {};
  removeCostId: number;
  Removecosting: any;
  addnewCosting: any = {};
  newCategoryForResourceChange: number;
  editedCostingTimeunit: number;
  categoryIndexToIDDict: any = {};
  // waiticon to show process in progress for all models
  waiticon = '';
  canRemoveCategory: boolean;
  clickedOnce = false;
  public currencySymbol: string;
  public currencyName: string;

  modalNewResourceAction = new EventEmitter<string | MaterializeAction>();
  modalNewCategoryAction = new EventEmitter<string | MaterializeAction>();
  modalEditResourceAction = new EventEmitter<string | MaterializeAction>();
  modalNewLocationAction = new EventEmitter<string | MaterializeAction>();
  modalEditCategoryAction = new EventEmitter<string | MaterializeAction>();
  modalConfirmRemoveCostTypeAction = new EventEmitter<string | MaterializeAction>();
  modalConfirmRemoveCategoryAction = new EventEmitter<string | MaterializeAction>();
  modalConfirmRemoveResourceAction = new EventEmitter<string | MaterializeAction>();

  constructor(private router: Router,
    public resourceadminservice: resourceAdminService,
    private ngZone: NgZone,
    public navService: NavbarService) { }

    ngOnDestroy() {
      this.modalNewResourceAction.emit({ action: 'modal', params: ['close'] });
      this.modalNewCategoryAction.emit({ action: 'modal', params: ['close'] });
      this.modalEditResourceAction.emit({ action: 'modal', params: ['close'] });
      this.modalNewLocationAction.emit({ action: 'modal', params: ['close'] });
      this.modalEditCategoryAction.emit({ action: 'modal', params: ['close'] });
      this.modalConfirmRemoveCostTypeAction.emit({ action: 'modal', params: ['close'] });
      this.modalConfirmRemoveCategoryAction.emit({ action: 'modal', params: ['close'] });
      this.modalConfirmRemoveResourceAction.emit({ action: 'modal', params: ['close'] });
    }

    ngOnInit() {
      this.navService.show('RESOURCE ADMIN');
      this.navService.setNavID(4);
      this.planid = localStorage.getItem('mr_planid');
      this.currencySymbol = localStorage.getItem('mr_currency_symbol');
      this.currencyName = localStorage.getItem('mr_currency_id');

      this.noResource = true;
      this.loadingResources = true;

      this.planid = localStorage.getItem('mr_planid');
      let admin = localStorage.getItem('isAdmin');

      // this.loadingcustomers = true;
      this.refreshResources();
    }

    refreshResources() {

      this.loadingResources = true;
      this.resources = null;
      this.categories = [];
      this.locations = [];
      this.costtypes = null;
      this.costtypeunits = null;
      this.costings = null;
      this.addnewCosting = {};
      this.resourceadminservice.getResources()
      .subscribe(
        data => {

          console.log('Got resources');
          let jsondata = JSON.parse(data);
          // this.tempusers = userdata.users;
          // console.log(jsondata);


          this.resources = jsondata.resources;
          console.log('RESOURCES:', this.resources);


          let category = JSON.stringify({
            id: 0, name: 'Choose Category', enabled: 3
          });

          let categoryJson = JSON.parse(category);

          this.categories = jsondata.categories;

          for (let i = 0; i < this.categories.length; i++) {
            this.categoriesDict[this.categories[i].id] = this.categories[i].name;
            this.categoryIndexToIDDict[this.categories[i].id] = i + 1;
          }

          // temp
          if (this.categories.length > 0) {
            this.noResource = false;
          }
          let location = JSON.stringify({
            id: 0, name: 'Choose Location', enabled: 3
          });

          let locationJson = JSON.parse(location);
          this.locations = jsondata.locations;


          for (let i = 0; i < this.locations.length; i++) {
            this.locationDict[this.locations[i].id] = this.locations[i].name;
          }

          this.costtypes = jsondata.costtypes;
          for (let i = 0; i < this.costtypes.length; i++) {
            this.costingtypeDict[this.costtypes[i].id] = this.costtypes[i].name;
          }
          this.costtypeunits = jsondata.costtypeunits;
          this.costtypeunits = this.costtypeunits.slice().reverse();
          for (let i = 0; i < this.costtypeunits.length; i++) {
            this.costtypeunitsDict[this.costtypeunits[i].id] = this.costtypeunits[i].name;
          }
          this.costings = jsondata.costings;

          this.categories.splice(0, 0, categoryJson);
          this.locations.splice(0, 0, locationJson);

          this.loadingResources = false;
          if (this.editcategoryIndex) {
            this.ngZone.onMicrotaskEmpty.first().subscribe(() => {
              document.getElementById('category' + this.editcategoryIndex).click();
            });
          }
        },
        error => {
          this.loadingResources = false;
          this.noResource = true;
          // this.loadingcustomers = false;
        });
      }

      onCategoryChange(value) {
        console.log('Category value', value);
        this.Categoryselect = value;
      }

      onLocationChange(value) {
        console.log('Location value', value);
        this.Locationselect = value;
      }

      onCosttypeunitChange(value) {
        console.log('Cost type unit change', value);
        this.CosttypeUnitselect = value;
      }

      onNewCategoryForResourceChange(value) {
        this.newCategoryForResourceChange = value;
      }

      // ontimeUnitForCostingChange(value){
      //   this.editedCostingTimeunit = value;
      // }

      /**
      * Emits modalNewResourceAction to take input from user for Resource.
      * Clears Resourcevalue for empty input field of Resource.
      *
      * @return void
      *
      */
      openNewResourceModal() {
        this.waiticon = '';


        (<HTMLInputElement>document.getElementById('resourceName')).value = null;
        (<HTMLInputElement>document.getElementById('resourceSelectedCategoryId')).value = '0';
        (<HTMLInputElement>document.getElementById('resource_desc')).value = null;
        (<HTMLInputElement>document.getElementById('resourceSelectedLocationId')).value = '0';

        (<HTMLInputElement>document.getElementById('batch_level')).checked = null;
        (<HTMLInputElement>document.getElementById('unit_level')).checked = null;
        (<HTMLInputElement>document.getElementById('nre')).checked = null;
        (<HTMLInputElement>document.getElementById('batch_level_desc')).value = null;
        (<HTMLInputElement>document.getElementById('batch_level_unit_id')).value = null;
        (<HTMLInputElement>document.getElementById('batch_level_cost_timeUnit')).value = null;
        (<HTMLInputElement>document.getElementById('batch_level_burden')).value = null;


        (<HTMLInputElement>document.getElementById('unit_level_desc')).value = null;
        (<HTMLInputElement>document.getElementById('unit_level_unit_id')).value = null;
        (<HTMLInputElement>document.getElementById('unit_level_cost_timeUnit')).value = null;
        (<HTMLInputElement>document.getElementById('unit_level_burden')).value = null;

        (<HTMLInputElement>document.getElementById('nre_desc')).value = null;
        (<HTMLInputElement>document.getElementById('nre_unit_id')).value = null;
        (<HTMLInputElement>document.getElementById('nre_cost_timeUnit')).value = null;
        (<HTMLInputElement>document.getElementById('nre_burden')).value = null;


        (<HTMLInputElement>document.getElementById('batch_level_desc'))['disabled'] = true;
        (<HTMLInputElement>document.getElementById('batch_level_unit_id'))['disabled'] = true;
        (<HTMLInputElement>document.getElementById('batch_level_cost_timeUnit'))['disabled'] = true;
        (<HTMLInputElement>document.getElementById('batch_level_burden'))['disabled'] = true;
        (<HTMLInputElement>document.getElementById('unit_level_desc'))['disabled'] = true;
        (<HTMLInputElement>document.getElementById('unit_level_unit_id'))['disabled'] = true;
        (<HTMLInputElement>document.getElementById('unit_level_cost_timeUnit'))['disabled'] = true;
        (<HTMLInputElement>document.getElementById('unit_level_burden'))['disabled'] = true;
        (<HTMLInputElement>document.getElementById('nre_desc'))['disabled'] = true;
        (<HTMLInputElement>document.getElementById('nre_unit_id'))['disabled'] = true;
        (<HTMLInputElement>document.getElementById('nre_cost_timeUnit'))['disabled'] = true;
        (<HTMLInputElement>document.getElementById('nre_burden'))['disabled'] = true;



        this.modalNewResourceAction.emit({ action: 'modal', params: ['open'] });
      }

      /**
      * Emits modalNewCategoryAction to take input from user for Category.
      * Clears Category value for empty input field of Category.
      *
      * @return void
      *
      */
      openNewCategoryModal() {

        this.waiticon = '';
        (<HTMLInputElement>document.getElementById('category_name')).value = '';
        this.modalNewCategoryAction.emit({ action: 'modal', params: ['open'] });
      }

      /**
      * Emits modalEditResourceAction to edit resource.
      * Update UI with current resource values.
      *
      * @param Resourc object
      *
      * @return void
      */
      openEditResourceModal(Resource: any, categoryid: number) {
        this.resourcesEdit = Resource;
        this.editcategoryIndex = categoryid;
        let j = 0;
        let ResourceCostingarray = [];
        this.selectedResourceCostingArray = [];
        for (let i = 0; i < this.costings.length; i++) {
          if (this.resourcesEdit.costings.includes(this.costings[i].id)) {
            ResourceCostingarray[j] = this.costings[i];
            j++;
          }
        }
        let k = 0;
        let costtypeidpresence = false;
        for (let i = 0; i < this.costtypes.length; i++) {
          costtypeidpresence = false;
          for (let j = 0; j < ResourceCostingarray.length; j++) {
            if (ResourceCostingarray[j].costtype_id === this.costtypes[i].id) {
              this.selectedResourceCostingArray[k] = ResourceCostingarray[j];
              costtypeidpresence = true;
              k++;
            }
          }

          if (!costtypeidpresence) {
            this.selectedResourceCostingArray[k] = {};
            this.selectedResourceCostingArray[k].costtype_id = this.costtypes[i].id;
            this.selectedResourceCostingArray[k].enabled = 0;
            costtypeidpresence = false;
            k++;
          }

        }
        this.modalEditResourceAction.emit({ action: 'modal', params: ['open'] });
      }


      /**
      * edit resource row and save in local data.
      * Update UI with new resource values.
      *
      * @param Resourc object
      *
      * @return void
      */
      resourceRowEditClicked(control) {
        document.getElementById(control).style.display = 'none';
        document.getElementById(control + 'Edit').style.display = 'block';

        this.activateResourceRowEditOption(control);
      }

      resourceRowEditSaveClicked(control) {

        document.getElementById(control).style.display = 'block';
        document.getElementById(control + 'Edit').style.display = 'none';
        this.deactivateResourceRowEditOption(control);
      }

      resourceRowEditCancalClicked(control) {

        document.getElementById(control).style.display = 'block';
        document.getElementById(control + 'Edit').style.display = 'none';

        this.deactivateResourceRowEditOption(control);
      }

      activateResourceRowEditOption(control) {
        document.getElementById(control + 'Pencil').style.display = 'none';
        document.getElementById(control + 'Apply').style.display = 'block';
        document.getElementById(control + 'Cancel').style.display = 'block';
      }

      deactivateResourceRowEditOption(control) {
        document.getElementById(control + 'Pencil').style.display = 'block';
        document.getElementById(control + 'Apply').style.display = 'none';
        document.getElementById(control + 'Cancel').style.display = 'none';
      }


      /**
      * Emits modalEditResourceAction to edit resource.
      * Update UI with new resourc values.
      *
      *
      * @return void
      */
      editResourceModalSubmit() {
        this.waiticon = 'fa right fa-spinner fa-pulse';

      }


      /**
      * Emits modalNewLocationAction to take input from user for Location.
      * Clears locationValue for empty input field of Location.
      *
      * @return void
      *
      */
      openNewLocationModal() {
        this.waiticon = '';
        (<HTMLInputElement>document.getElementById('location_name')).value = '';
        this.modalNewLocationAction.emit({ action: 'modal', params: ['open'] });
      }

      /**
      * Emits modalEditCategoryAction to take input from user for new category name.
      * stores selectedCategoryName.
      *
      * @return void
      *
      */
      openEditCategoryModal(category: any) {

        document.getElementById('categoryName').style.display = 'block';
        document.getElementById('categoryNameEdit').style.display = 'none';
        document.getElementById('categoryNamePencil').style.display = 'block';
        document.getElementById('categoryNameApply').style.display = 'none';
        document.getElementById('categoryNameCancel').style.display = 'none';

        this.selectedCategoryValueName = category.name;
        this.selectedCategoryValue = category;
        this.modalEditCategoryAction.emit({ action: 'modal', params: ['open'] });
      }

      /**
      * inables submit and cancal
      * stores selectedCategoryName.
      *
      * @return void
      *
      */
      categoryEditClicked() {
        document.getElementById('categoryName').style.display = 'none';
        document.getElementById('categoryNameEdit').style.display = 'block';

        document.getElementById('categoryNamePencil').style.display = 'none';
        document.getElementById('categoryNameApply').style.display = 'inline-block';
        document.getElementById('categoryNameCancel').style.display = 'inline-block';

        // this.activateResourceRowEditOption(control);
      }
      categoryEditSaveClicked() {

        let categorname = (<HTMLInputElement>document.getElementById('categoryNameEdit')).value;

        if (categorname.length <= 0) {
          Materialize.toast('PLEASE ADD CATEGORY NAME.', 1500);
          return;
        }

        this.selectedCategoryValueName = categorname;
        document.getElementById('categoryName').style.display = 'block';
        document.getElementById('categoryNameEdit').style.display = 'none';
        document.getElementById('categoryNamePencil').style.display = 'block';
        document.getElementById('categoryNameApply').style.display = 'none';
        document.getElementById('categoryNameCancel').style.display = 'none';

        this.editCategorySubmit();
      }
      categoryEditCancelClicked() {

        this.selectedCategoryValue.name = this.selectedCategoryValueName;

        document.getElementById('categoryName').style.display = 'block';
        document.getElementById('categoryNameEdit').style.display = 'none';
        document.getElementById('categoryNamePencil').style.display = 'block';
        document.getElementById('categoryNameApply').style.display = 'none';
        document.getElementById('categoryNameCancel').style.display = 'none';
      }
      openConfirmRemoveCostTypeModal() {
        this.modalConfirmRemoveCostTypeAction.emit({ action: 'modal', params: ['open'] });
      }

      openConfirmRemoveCategoryModal(category: any, categoryIndex) {

        let canRemoveCategory = 'true';
        this.selectedCategoryValueName = category.name;
        this.editcategoryIndex = categoryIndex;
        this.selectedCategoryValue = category;
        this.canRemoveCategory = true;
        this.selectedResources = [];

        for (let i = 0; i < this.resources.length; i++) {
          if (category.id == this.resources[i].category_id) {
            this.canRemoveCategory = false;
            this.selectedResources.push(this.resources[i].id);
            // continue;
          }
        }

        this.modalConfirmRemoveCategoryAction.emit({ action: 'modal', params: ['open'] });
      }

      openConfirmRemoveResourceModal(resource: any, categoryIndex) {
        this.editcategoryIndex = categoryIndex;
        this.selectedResourceValue = resource;
        this.modalConfirmRemoveResourceAction.emit({ action: 'modal', params: ['open'] });
      }

      RemoveResourceConfirm() {
        // removeResource
        this.waiticon = 'fa right fa-spinner fa-pulse';
        this.resourceadminservice.removeResource(this.selectedResourceValue)
        .subscribe(
          data => {
            // Need to add return check
            // this.modalEditCategoryAction.emit({ action: "modal", params: ['close'] });
            Materialize.toast('RESOURCE ' + this.selectedResourceValue.name + ' REMOVED.', 1500);
            console.log('RESOURCE' + this.selectedResourceValue.name + 'REMOVED.');

            this.refreshResources();
            this.modalConfirmRemoveResourceAction.emit({ action: 'modal', params: ['close'] });
            this.waiticon = '';
          },
          error => {
            Materialize.toast('PLEASE TRY AGAIN.', 1500);
            console.log('PLEASE TRY AGAIN.');
            this.waiticon = '';
          });
        }


        /**
        * Called from collapsible resource Header to make changes in UI and
        *
        * @param
        *
        * @return   void
        */
        resourceHeaderClicked(index: number) {
          console.log('resourceHeaderClicked');
          console.log(' Index : ', index);

          if (document.getElementById(index + '_collapsible_body').className != 'active') {

            document.getElementById('categoryarrowexpand' + index).style.display = 'block';
            document.getElementById('categoryarrowright' + index).style.display = 'none';

            document.getElementById('categoryRemove' + index).className = 'visibility-Vis';
            document.getElementById('categoryEdit' + index).className = 'visibility-Vis';


          } else {
            document.getElementById('categoryarrowexpand' + index).style.display = 'none';
            document.getElementById('categoryarrowright' + index).style.display = 'block';

            document.getElementById('categoryEdit' + index).className = 'visibility-Hid';
            document.getElementById('categoryRemove' + index).className = 'visibility-Hid';
          }

          let rows = document.getElementById('resourcetabel' + index).getElementsByTagName('tbody')[0].getElementsByTagName('tr').length;

          if (rows <= 0) {
            document.getElementById('filledcategory' + index).style.display = 'none';
          } else {
            document.getElementById('emptycategory' + index).style.display = 'none';
          }

        }

        /**
        * Called from modalNewCategoryAction model
        * Calls createNewCategory with category_name to create new Category.
        *
        * @return void
        */
        createNewCategorySubmit() {
          this.waiticon = 'fa right fa-spinner fa-pulse';
          let category_name = (<HTMLInputElement>document.getElementById('category_name')).value;

          if (!category_name) {
            Materialize.toast('PLEASE ADD CATEGORY NAME.', 1500);
            console.log('PLEASE ADD CATEGORY NAME.');
            this.waiticon = '';
          } else {
            this.createNewCategory(category_name.toUpperCase());
          }
        }

        editRow(control) {
          console.log('control : ', control, ' project : ', this.resourcesEdit);
          document.getElementById(control).style.display = 'none';
          document.getElementById(control + 'Edit').style.display = 'block';

          document.getElementById(control + 'Pencil').style.display = 'none';
          document.getElementById(control + 'Apply').style.display = 'inline-block';
          document.getElementById(control + 'Cancel').style.display = 'inline-block';

          this.Categoryselect = this.resourcesEdit.category_id;
          (<HTMLInputElement>document.getElementById('category_idselectEdit')).value = this.Categoryselect;
          this.Locationselect = this.resourcesEdit.location_id;
          (<HTMLInputElement>document.getElementById('location_idselectEdit')).value = this.Locationselect;
        }

        cancelEditRow(control) {
          document.getElementById(control).style.display = 'block';
          document.getElementById(control + 'Edit').style.display = 'none';
          (<HTMLInputElement>document.getElementById(control + 'Edit')).value = this.resourcesEdit[control];

          document.getElementById(control + 'Pencil').style.display = 'block';
          document.getElementById(control + 'Apply').style.display = 'none';
          document.getElementById(control + 'Cancel').style.display = 'none';
        }

        saveRow(control) {
          document.getElementById(control).style.display = 'block';
          document.getElementById(control + 'Edit').style.display = 'none';
          this.resourcesEdit[control] = (<HTMLInputElement>document.getElementById(control + 'Edit')).value;
          this.resourcesEdit.category_id = Number(this.Categoryselect);
          this.resourcesEdit.location_id = Number(this.Locationselect);

          document.getElementById(control + 'Pencil').style.display = 'block';
          document.getElementById(control + 'Apply').style.display = 'none';
          document.getElementById(control + 'Cancel').style.display = 'none';


          let updateResource = {
            id: this.resourcesEdit.id,
            name: this.resourcesEdit.name,
            category_id: this.resourcesEdit.category_id,
            description: this.resourcesEdit.description,
            location_id: this.resourcesEdit.location_id

          };

          let costing = {};
          this.resourceadminservice.updateResource(updateResource)
          .subscribe(
            data => {
              console.log('Resorce updated to DB');
              Materialize.toast('PROPERTY UPDATED SUCCESSFULLY', 2000);
            },
            error => {
            });
          }

          editCostingRow(index) {

            document.getElementById('costdescription' + index).style.display = 'none';
            document.getElementById('costdescriptionEdit' + index).style.display = 'block';

            document.getElementById('costtimeunit' + index).style.display = 'none';
            document.getElementById('costtimeunitEdit' + index).style.display = 'inline-block';
            (<HTMLInputElement>document.getElementById('costtimeunitselectEdit' + index)).value = this.selectedResourceCostingArray[index].costtypeunit_id;

            document.getElementById('cost' + index).style.display = 'none';
            document.getElementById('costEdit' + index).style.display = 'block';

            document.getElementById('costburden' + index).style.display = 'none';
            document.getElementById('costburdenEdit' + index).style.display = 'inline-block';

            document.getElementById('costingPencil' + index).style.display = 'none';
            document.getElementById('costingApply' + index).style.display = 'inline-block';
            document.getElementById('costingCancel' + index).style.display = 'inline-block';

            this.CosttypeUnitselect = this.selectedResourceCostingArray[index].costtypeunit_id;
          }

          saveCostingRow(index) {
            document.getElementById('costdescription' + index).style.display = 'block';
            document.getElementById('costdescriptionEdit' + index).style.display = 'none';
            this.selectedResourceCostingArray[index].description = (<HTMLInputElement>document.getElementById('costdescriptionEdit' + index)).value;

            document.getElementById('costtimeunit' + index).style.display = 'block';
            document.getElementById('costtimeunitEdit' + index).style.display = 'none';

            document.getElementById('cost' + index).style.display = 'block';
            document.getElementById('costEdit' + index).style.display = 'none';
            this.selectedResourceCostingArray[index].cost = (<HTMLInputElement>document.getElementById('costEdit' + index)).value;

            document.getElementById('costburden' + index).style.display = 'block';
            document.getElementById('costburdenEdit' + index).style.display = 'none';
            this.selectedResourceCostingArray[index].burden = (<HTMLInputElement>document.getElementById('costburdenEdit' + index)).value;

            document.getElementById('costingPencil' + index).style.display = 'block';
            document.getElementById('costingApply' + index).style.display = 'none';
            document.getElementById('costingCancel' + index).style.display = 'none';
            if (!this.CosttypeUnitselect) {
              this.CosttypeUnitselect = 3;
            }
            this.selectedResourceCostingArray[index].costtypeunit_id = this.CosttypeUnitselect;

            if (this.addnewCosting.newcost) {
              let newcosting = {
                costtype_id: this.addnewCosting.costtype_id,
                resource_id: this.addnewCosting.resource_id,
                description: this.selectedResourceCostingArray[index].description,
                costtypeunit_id: this.CosttypeUnitselect,
                cost: this.selectedResourceCostingArray[index].cost,
                burden: this.selectedResourceCostingArray[index].burden
              };
              this.resourceadminservice.addCosting(newcosting)
              .subscribe(
                data => {
                  console.log('Added new Costing');
                  Materialize.toast('COST TYPE UPDATED SUCCESSFULLY', 1500);
                  this.modalEditResourceAction.emit({ action: 'modal', params: ['close'] });
                  this.refreshResources();
                }
              );
            } else {
              let costing = {
                id: this.selectedResourceCostingArray[index].id,
                description: this.selectedResourceCostingArray[index].description,
                costtypeunit_id: this.CosttypeUnitselect,
                cost: this.selectedResourceCostingArray[index].cost,
                burden: this.selectedResourceCostingArray[index].burden
              };
              this.resourceadminservice.updateCosting(costing)
              .subscribe(
                data => {
                  console.log('Costing updated to DB');
                  Materialize.toast('COST TYPE UPDATED.', 1000);
                },
                error => {
                });
              }
            }

            cancelCostingRow(index) {
              document.getElementById('costdescription' + index).style.display = 'block';
              document.getElementById('costdescriptionEdit' + index).style.display = 'none';
              // this.projects[index].name = (<HTMLInputElement>document.getElementById('nameEdit' + index)).value;

              document.getElementById('costtimeunit' + index).style.display = 'block';
              document.getElementById('costtimeunitEdit' + index).style.display = 'none';
              // this.projects[index].number = (<HTMLInputElement>document.getElementById('numberEdit' + index)).value;

              document.getElementById('cost' + index).style.display = 'block';
              document.getElementById('costEdit' + index).style.display = 'none';
              // this.projects[index].revision = (<HTMLInputElement>document.getElementById('revisionEdit' + index)).value;

              document.getElementById('costburden' + index).style.display = 'block';
              document.getElementById('costburdenEdit' + index).style.display = 'none';

              document.getElementById('costingPencil' + index).style.display = 'block';
              document.getElementById('costingApply' + index).style.display = 'none';
              document.getElementById('costingCancel' + index).style.display = 'none';
            }

            editResourceCancel() {
              for (let index = 0; index < 3; index++) {
                document.getElementById('costdescription' + index).style.display = 'block';
                document.getElementById('costdescriptionEdit' + index).style.display = 'none';
                // this.projects[index].name = (<HTMLInputElement>document.getElementById('nameEdit' + index)).value;

                document.getElementById('costtimeunit' + index).style.display = 'block';
                document.getElementById('costtimeunitEdit' + index).style.display = 'none';
                // this.projects[index].number = (<HTMLInputElement>document.getElementById('numberEdit' + index)).value;

                document.getElementById('cost' + index).style.display = 'block';
                document.getElementById('costEdit' + index).style.display = 'none';
                // this.projects[index].revision = (<HTMLInputElement>document.getElementById('revisionEdit' + index)).value;

                document.getElementById('costburden' + index).style.display = 'block';
                document.getElementById('costburdenEdit' + index).style.display = 'none';

                document.getElementById('costingPencil' + index).style.display = 'block';
                document.getElementById('costingApply' + index).style.display = 'none';
                document.getElementById('costingCancel' + index).style.display = 'none';
              }

              let allcontrols = [];
              allcontrols[0] = 'name';
              allcontrols[1] = 'category_id';
              allcontrols[2] = 'description';
              allcontrols[3] = 'location_id';

              for (let i = 0; i < allcontrols.length; i++) {
                document.getElementById(allcontrols[i]).style.display = 'block';
                document.getElementById(allcontrols[i] + 'Edit').style.display = 'none';
                (<HTMLInputElement>document.getElementById(allcontrols[i] + 'Edit')).value = this.resourcesEdit[allcontrols[i]];

                document.getElementById(allcontrols[i] + 'Pencil').style.display = 'block';
                document.getElementById(allcontrols[i] + 'Apply').style.display = 'none';
                document.getElementById(allcontrols[i] + 'Cancel').style.display = 'none';
              }
            }

            /**
            * Create New Category in MR2 Database
            * Calls addCategory service with category_name to create new Category in datbase.
            *
            * @return void
            */
            createNewCategory(category_name: string) {
              this.resourceadminservice.addNewCategory(category_name).subscribe(
                data => {
                  try {
                    let json = JSON.parse(data);
                    if (json == true) {
                      this.waiticon = '';
                      this.refreshResources();
                      Materialize.toast('CATEGORY ' + category_name + ' CREATED SUCCESSFULLY.', 1500);
                      console.log('CATEGORY CONSUMABLES CREATED SUCCESSFULLY.');
                      this.modalNewCategoryAction.emit({ action: 'modal', params: ['close'] });
                    } else {
                      Materialize.toast('CATEGORY IS ALREADY PRESENT. PLEASE TRY AGAIN WITH ANOTHER CATEGORY NAME.', 1500);
                      console.log('CATEGORY IS ALREADY PRESENT. PLEASE TRY AGAIN WITH ANOTHER CATEGORY NAME.');
                      this.waiticon = '';
                    }
                  } catch (e) {
                    console.log('CATEGORY IS ALREADY PRESENT, PLEASE TRY WITH ANOTHER CATEGORY NAME.  ' + data);
                    Materialize.toast('CATEGORY IS ALREADY PRESENT, PLEASE TRY WITH ANOTHER CATEGORY NAME.', 1500);
                    this.waiticon = '';
                  }
                },
                error => {
                  console.log('INTERNAL  ERROR WHILE ADDING CATEGORY NAME : ' + error);
                  Materialize.toast('INTERNAL  ERROR WHILE ADDING CATEGORY NAME.', 1500);
                  this.waiticon = '';
                });
              }

              /**
              * Called from createNewLocation model
              * Calls createNewLocation with loaction_name to create new location.
              *
              * @return void
              */
              createNewLocationSubmit() {
                this.waiticon = 'fa right fa-spinner fa-pulse';
                let loaction_name = (<HTMLInputElement>document.getElementById('location_name')).value;
                if (!loaction_name) {

                  Materialize.toast('PLEASE ADD LOCATION NAME.', 1500);
                  console.log('PLEASE ADD LOCATION NAME.');
                  this.waiticon = '';
                } else {
                  this.createNewLocation(loaction_name);
                }
              }

              /**
              * Create New Location in MR2 Database
              * Calls createNewLocationservice with loaction_name to create new location in datbase.
              *
              * @return void
              */
              createNewLocation(loaction_name: string) {
                this.resourceadminservice.addNewLocation(loaction_name).subscribe(
                  data => {
                    try {
                      let json = JSON.parse(data);
                      if (json == true) {
                        this.waiticon = '';
                        this.refreshResources();
                        Materialize.toast('LOCATION ' + loaction_name + ' CREATED SUCCESSFULLY.', 1500);
                        //   this.getusers();
                        console.log('LOCATION ' + loaction_name + ' CREATED SUCCESSFULLY');
                        this.modalNewLocationAction.emit({ action: 'modal', params: ['close'] });
                      } else {
                        Materialize.toast('LOCATION IS ALREADY PRESENT, PLEASE TRY WITH ANOTHER LOCATION NAME.', 1500);
                        console.log('LOCATION IS ALREADY PRESENT, PLEASE TRY WITH ANOTHER LOCATION NAME.');
                        this.waiticon = '';
                      }
                    } catch (e) {
                      console.log('ERROR ADDING LOCATION.' + e);
                      Materialize.toast('INTERNAL ERROR WHILE ADDING LOCATION NAME.', 1500);
                      this.waiticon = '';
                    }
                  },
                  error => {
                    console.log('ERROR ADDING LOCATION.' + error);
                    Materialize.toast('INTERNAL ERROR WHILE ADDING LOCATION NAME.', 1500);
                    this.waiticon = '';
                  });
                }


                /**
                * Called from createNewResource model
                * Calls createNewResource with resoucre_name to create new location.
                *
                * @return void
                */
                createNewResourceSubmit() {
                  this.waiticon = 'fa right fa-spinner fa-pulse';

                  let resource: any = {};

                  let resourceName = (<HTMLInputElement>document.getElementById('resourceName')).value;
                  let resourceSelectedCategoryId = (<HTMLInputElement>document.getElementById('resourceSelectedCategoryId')).value;
                  let resource_desc = (<HTMLInputElement>document.getElementById('resource_desc')).value;
                  let resourceSelectedLocationId = (<HTMLInputElement>document.getElementById('resourceSelectedLocationId')).value;

                  console.log('resourceName:', resourceName);
                  console.log('resourceSelectedCategoryId:', resourceSelectedCategoryId);
                  console.log('resourceSelectedLocationId:', resourceSelectedLocationId);


                  if (resourceName.length <= 0 || resourceSelectedCategoryId == '0') {
                    this.waiticon = '';
                    console.log('RESOURCE AND CATEGORY ARE REQUIRED FIELDS.');
                    Materialize.toast('RESOURCE AND CATEGORY ARE REQUIRED FIELDS.', 1500);
                    return;
                  }

                  resource.name = resourceName;
                  resource.category_id = parseInt(resourceSelectedCategoryId);
                  this.editcategoryIndex = this.categoryIndexToIDDict[resource.category_id];
                  resource.description = resource_desc;
                  resource.location_id = parseInt(resourceSelectedLocationId)
                  ;

                  let costing = [];
                  let batchLevelCheckbox = (<HTMLInputElement>document.getElementById('batch_level')).checked;
                  let unitLevelCheckbox = (<HTMLInputElement>document.getElementById('unit_level')).checked;
                  let nonRecurringCheckbox = (<HTMLInputElement>document.getElementById('nre')).checked;

                  if (batchLevelCheckbox != true && unitLevelCheckbox != true && nonRecurringCheckbox != true) {
                    this.waiticon = '';
                    console.log('AT LEAST ONE COST TYPE MUST BE DEFINED.');
                    Materialize.toast('AT LEAST ONE COST TYPE MUST BE DEFINED.', 1500);
                    return;
                  }

                  if (batchLevelCheckbox == true) {
                    let batch_level_desc = (<HTMLInputElement>document.getElementById('batch_level_desc')).value;
                    let batch_level_unit_id = (<HTMLInputElement>document.getElementById('batch_level_unit_id')).value;
                    let batchLevelCostTimeUnit = (<HTMLInputElement>document.getElementById('batch_level_cost_timeUnit')).value;
                    let batchLevelBurden = (<HTMLInputElement>document.getElementById('batch_level_burden')).value;

                    if (batch_level_desc.length <= 0) {
                      this.waiticon = '';
                      console.log('COST TYPE DESCRIPTION IS REQUIRED.');
                      Materialize.toast('COST TYPE DESCRIPTION IS REQUIRED.', 1500);
                      return;
                    }

                    let batchLevel: any = {};
                    batchLevel.description = batch_level_desc;
                    batchLevel.costtype_id = 1;
                    batchLevel.costtypeunit_id = parseInt(batch_level_unit_id);
                    batchLevel.cost = parseFloat(batchLevelCostTimeUnit);
                    batchLevel.burden = parseFloat(batchLevelBurden);

                    costing.push(batchLevel);
                  }


                  if (unitLevelCheckbox == true) {
                    let unit_level_desc = (<HTMLInputElement>document.getElementById('unit_level_desc')).value;
                    let unit_level_unit_id = (<HTMLInputElement>document.getElementById('unit_level_unit_id')).value;
                    let unitLevelCostTimeUnit = (<HTMLInputElement>document.getElementById('unit_level_cost_timeUnit')).value;
                    let unitLevelBurden = (<HTMLInputElement>document.getElementById('unit_level_burden')).value;

                    if (unit_level_desc.length <= 0) {
                      this.waiticon = '';
                      console.log('COST TYPE DESCRIPTION IS REQUIRED.');
                      Materialize.toast('COST TYPE DESCRIPTION IS REQUIRED.', 1500);
                      return;
                    }

                    let unitLevel: any = {};
                    unitLevel.description = unit_level_desc;
                    unitLevel.costtype_id = 2;
                    unitLevel.costtypeunit_id = parseInt(unit_level_unit_id);
                    unitLevel.cost = parseFloat(unitLevelCostTimeUnit);
                    unitLevel.burden = parseFloat(unitLevelBurden);

                    costing.push(unitLevel);
                  }


                  if (nonRecurringCheckbox == true) {
                    let nre_desc = (<HTMLInputElement>document.getElementById('nre_desc')).value;
                    let nre_unit_id = (<HTMLInputElement>document.getElementById('nre_unit_id')).value;
                    let nreCostTimeUnit = (<HTMLInputElement>document.getElementById('nre_cost_timeUnit')).value;
                    let nreBurden = (<HTMLInputElement>document.getElementById('nre_burden')).value;

                    if (nre_desc.length <= 0) {
                      this.waiticon = '';
                      console.log('COST TYPE DESCRIPTION IS REQUIRED.');
                      Materialize.toast('COST TYPE DESCRIPTION IS REQUIRED.', 1500);
                      return;
                    }

                    let nonRecurring: any = {};
                    nonRecurring.description = nre_desc;
                    nonRecurring.costtype_id = 3;
                    nonRecurring.costtypeunit_id = parseInt(nre_unit_id);
                    nonRecurring.cost = parseFloat(nreCostTimeUnit);
                    nonRecurring.burden = parseFloat(nreBurden);
                    costing.push(nonRecurring);
                  }

                  this.createNewResource(resource, costing);
                }

                /**
                * Create New Resource in MR2 Database
                * Calls addResource with resoucre_name to create new resource in datbase.
                *
                * @return void
                */
                createNewResource(resource: any, costing: any) {

                  this.resourceadminservice.addNewResource(resource, costing).subscribe(
                    data => {

                      Materialize.toast('RESOURCE ' + resource.name + '  CREATED SUCCESSFULLY.', 1500);
                      console.log('RESOURCE ' + resource.name + '  CREATED SUCCESSFULLY.');
                      this.modalNewResourceAction.emit({ action: 'modal', params: ['close'] });
                      this.refreshResources();
                      this.waiticon = '';

                    },
                    error => {
                      console.log('INTERNAL ERROR.' + error);
                      Materialize.toast('INTERNAL ERROR.', 1500);
                      this.waiticon = '';
                    });
                  }

                  editCategorySubmit() {
                    this.waiticon = 'fa right fa-spinner fa-pulse';
                    this.resourceadminservice.editCategory(this.selectedCategoryValue, this.selectedCategoryValueName.toUpperCase())
                    .subscribe(
                      data => {

                        try {
                          let json = JSON.parse(data);
                          if (json == true) {

                            this.selectedCategoryValue.name = this.selectedCategoryValueName.toUpperCase();
                            Materialize.toast('CATEGORY NAME UPDATED SUCCESSFULLY.', 1500);
                            console.log('CATEGORY NAME UPDATED SUCCESSFULLY.');
                            this.modalEditCategoryAction.emit({ action: 'modal', params: ['close'] });
                            this.waiticon = '';
                          }
                        } catch (e) {
                          console.log('ERROR UPDATING CATEGORY NAME.' + e);
                          Materialize.toast('ERROR UPDATING CATEGORY NAME.', 1500);
                          this.waiticon = '';
                        }
                      },
                      error => {
                        console.log('INTERNAL ERROR.');
                        Materialize.toast('INTERNAL ERROR.', 1500);
                        this.waiticon = '';
                      });
                    }


                    // Remove Category
                    RemoveCategoryConfirm() {
                      this.waiticon = 'fa right fa-spinner fa-pulse';
                      this.resourceadminservice.removeCategory(this.selectedCategoryValue)
                      .subscribe(
                        data => {
                          // Need to add return check
                          Materialize.toast('CATEGORY ' + this.selectedCategoryValue.name + ' REMOVED.', 1500);
                          this.refreshResources();
                          this.modalConfirmRemoveCategoryAction.emit({ action: 'modal', params: ['close'] });
                          this.waiticon = '';
                        },
                        error => {
                          Materialize.toast('INTERNAL ERROR.', 1500);
                          console.log('INTERNAL ERROR.');
                          this.waiticon = '';
                        });
                      }

                      updateResourcesCategory() {
                        this.waiticon = 'fa right fa-spinner fa-pulse';
                        let resourceSelectedCategoryId;
                        if (!this.newCategoryForResourceChange) {
                          resourceSelectedCategoryId = (<HTMLInputElement>document.getElementById('newCategoryForResource')).value;
                        } else {
                          resourceSelectedCategoryId = this.newCategoryForResourceChange;
                        } //  this.selectedResources
                        let oldCategory = this.selectedCategoryValue.id;

                        //  for(var i = 0; i < this.selectedResources.length; i++ )
                        //  {
                        this.waiticon = 'fa right fa-spinner fa-pulse';
                        this.resourceadminservice.updateResourcescategories(oldCategory, parseInt(resourceSelectedCategoryId))
                        .subscribe(
                          data => {
                            // Need to add return check
                            //  Materialize.toast("UpdateResourcesCategory " +i +" of "+ this.selectedResources.length , 1500);
                            this.waiticon = '';
                            this.canRemoveCategory = true;
                            //  this.refreshResources();
                          },
                          error => {
                            Materialize.toast('INTERNAL ERROR.', 1500);
                            console.log('INTERNAL ERROR.');
                            this.waiticon = '';
                          });

                          //  }
                        }

                        onChange(id: any) {

                          if ((<HTMLInputElement>document.getElementById(id))['checked']) {
                            (<HTMLInputElement>document.getElementById(id))['checked'] = false;
                            (<HTMLInputElement>document.getElementById(id + '_desc'))['disabled'] = true;
                            (<HTMLInputElement>document.getElementById(id + '_unit_id'))['disabled'] = true;
                            (<HTMLInputElement>document.getElementById(id + '_cost_timeUnit'))['disabled'] = true;
                            (<HTMLInputElement>document.getElementById(id + '_burden'))['disabled'] = true;

                          } else {

                            (<HTMLInputElement>document.getElementById(id))['checked'] = true;
                            (<HTMLInputElement>document.getElementById(id + '_desc'))['disabled'] = false;
                            (<HTMLInputElement>document.getElementById(id + '_unit_id'))['disabled'] = false;
                            (<HTMLInputElement>document.getElementById(id + '_cost_timeUnit'))['disabled'] = false;
                            (<HTMLInputElement>document.getElementById(id + '_burden'))['disabled'] = false;
                          }
                        }

                        toggleCheckBox(costing: any, id: any) {

                          if ((<HTMLInputElement>document.getElementById('checkbox' + id))['checked']) {
                            if (this.resourcesEdit.costings.length < 2) {
                              Materialize.toast('AT LEAST ONE COST TYPE MUST BE DEFINED PER RESOURCE', 1500);
                              return;
                            }
                            this.Removecosting = costing;
                            this.removeCostId = id;
                            this.openConfirmRemoveCostTypeModal();
                          } else {
                            costing.enabled = 1;
                            (<HTMLInputElement>document.getElementById('checkbox' + id))['checked'] = true;

                            (<HTMLInputElement>document.getElementById('costdescriptionEdit' + id)).value = null;
                            (<HTMLInputElement>document.getElementById('costdescriptionEdit' + id))['disabled'] = false;
                            (<HTMLInputElement>document.getElementById('costdescriptionEdit' + id)).style.display = 'block';

                            (<HTMLInputElement>document.getElementById('costtimeunitEdit' + id)).value = null;
                            (<HTMLInputElement>document.getElementById('costtimeunitEdit' + id))['disabled'] = false;
                            (<HTMLInputElement>document.getElementById('costtimeunitEdit' + id)).style.display = 'block';

                            (<HTMLInputElement>document.getElementById('costEdit' + id)).value = null;
                            (<HTMLInputElement>document.getElementById('costEdit' + id))['disabled'] = false;
                            (<HTMLInputElement>document.getElementById('costEdit' + id)).style.display = 'block';

                            (<HTMLInputElement>document.getElementById('costburdenEdit' + id)).value = null;
                            (<HTMLInputElement>document.getElementById('costburdenEdit' + id))['disabled'] = false;
                            (<HTMLInputElement>document.getElementById('costburdenEdit' + id)).style.display = 'block';

                            document.getElementById('costingPencil' + id).style.display = 'none';
                            document.getElementById('costingApply' + id).style.display = 'block';
                            document.getElementById('costingCancel' + id).style.display = 'block';
                            this.CosttypeUnitselect = 3;  // Default N/A value stored
                            this.addnewCosting = {
                              newcost: true,
                              costtype_id: costing.costtype_id,
                              resource_id: this.resourcesEdit.id
                            };

                            // this.resourceadminservice.addCosting(addcosting)
                            // .subscribe(
                            //   data=>{
                            //     Materialize.toast('Costing enabled. Please save edited values.', 2000);
                            //   },
                            //   error=>{
                            //   })
                          }
                        }

                        RemoveCostTypeConfirm() {
                          let id = this.removeCostId;
                          let resource = this.resourcesEdit;
                          this.waiticon = 'fa right fa-spinner fa-pulse';
                          (<HTMLInputElement>document.getElementById('checkbox' + id))['checked'] = false;

                          (<HTMLInputElement>document.getElementById('costdescription' + id)).value = null;
                          (<HTMLInputElement>document.getElementById('costdescriptionEdit' + id)).value = null;
                          (<HTMLInputElement>document.getElementById('costdescriptionEdit' + id))['disabled'] = true;
                          (<HTMLInputElement>document.getElementById('costdescriptionEdit' + id)).style.display = 'none';
                          (<HTMLInputElement>document.getElementById('costdescription' + id)).style.display = 'none';

                          (<HTMLInputElement>document.getElementById('costtimeunit' + id)).value = null;
                          (<HTMLInputElement>document.getElementById('costtimeunitEdit' + id)).value = null;
                          (<HTMLInputElement>document.getElementById('costtimeunitEdit' + id)).style.display = 'none';
                          (<HTMLInputElement>document.getElementById('costtimeunit' + id)).style.display = 'none';

                          (<HTMLInputElement>document.getElementById('cost' + id)).value = null;
                          (<HTMLInputElement>document.getElementById('costEdit' + id)).value = null;
                          (<HTMLInputElement>document.getElementById('costEdit' + id))['disabled'] = true;
                          (<HTMLInputElement>document.getElementById('costEdit' + id)).style.display = 'none';
                          (<HTMLInputElement>document.getElementById('cost' + id)).style.display = 'none';

                          (<HTMLInputElement>document.getElementById('costburden' + id)).value = null;
                          (<HTMLInputElement>document.getElementById('costburdenEdit' + id)).value = null;
                          (<HTMLInputElement>document.getElementById('costburdenEdit' + id))['disabled'] = true;
                          (<HTMLInputElement>document.getElementById('costburdenEdit' + id)).style.display = 'none';
                          (<HTMLInputElement>document.getElementById('costburden' + id)).style.display = 'none';

                          document.getElementById('costingPencil' + id).style.display = 'none';
                          document.getElementById('costingApply' + id).style.display = 'none';
                          document.getElementById('costingCancel' + id).style.display = 'none';

                          this.resourceadminservice.removeCosting(this.Removecosting.id).subscribe(
                            data => {
                              // this.resourceadminservice.removeCostingFromResource(this.resourcesEdit, this.Removecosting.id)
                              // .subscribe(
                              //   data => {
                              Materialize.toast('Costing Removed', 1000);
                              this.modalConfirmRemoveCostTypeAction.emit({ action: 'modal', params: ['close'] });
                              this.modalEditResourceAction.emit({ action: 'modal', params: ['open'] });
                              this.waiticon = '';
                              this.refreshResources();
                              // $('.collapsible').collapsible('open',0);
                              // },
                              // error => {

                              // })
                            },
                            error => {

                            });
                          }
                        }



// WEBPACK FOOTER //
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/resourceadmin/resourceadmin.component.ts